/* This is generated code, don't alter */
var IfcReflectanceMethodEnum;
(function (IfcReflectanceMethodEnum) {
    IfcReflectanceMethodEnum[IfcReflectanceMethodEnum["BLINN"] = 0] = "BLINN";
    IfcReflectanceMethodEnum[IfcReflectanceMethodEnum["FLAT"] = 1] = "FLAT";
    IfcReflectanceMethodEnum[IfcReflectanceMethodEnum["GLASS"] = 2] = "GLASS";
    IfcReflectanceMethodEnum[IfcReflectanceMethodEnum["MATT"] = 3] = "MATT";
    IfcReflectanceMethodEnum[IfcReflectanceMethodEnum["METAL"] = 4] = "METAL";
    IfcReflectanceMethodEnum[IfcReflectanceMethodEnum["MIRROR"] = 5] = "MIRROR";
    IfcReflectanceMethodEnum[IfcReflectanceMethodEnum["PHONG"] = 6] = "PHONG";
    IfcReflectanceMethodEnum[IfcReflectanceMethodEnum["PLASTIC"] = 7] = "PLASTIC";
    IfcReflectanceMethodEnum[IfcReflectanceMethodEnum["STRAUSS"] = 8] = "STRAUSS";
    IfcReflectanceMethodEnum[IfcReflectanceMethodEnum["NOTDEFINED"] = 9] = "NOTDEFINED";
})(IfcReflectanceMethodEnum || (IfcReflectanceMethodEnum = {}));
const IfcReflectanceMethodEnumCount = 10;
export { IfcReflectanceMethodEnum, IfcReflectanceMethodEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcReflectanceMethodEnum = new Int32Array([46, 10, 1]);
let prefixSumAddressIfcReflectanceMethodEnum = new Uint32Array([0, 7, 19, 25, 34, 42, 51, 58, 64, 71, 78]);
let slotMapIfcReflectanceMethodEnum = new Int32Array([6, 9, 3, 7, 5, 8, 0, 1, 2, 4]);
let encodedDataIfcReflectanceMethodEnum = (new TextEncoder()).encode(".PHONG..NOTDEFINED..MATT..PLASTIC..MIRROR..STRAUSS..BLINN..FLAT..GLASS..METAL.");
let IfcReflectanceMethodEnumSearch = new MinimalPerfectHash(gMapIfcReflectanceMethodEnum, prefixSumAddressIfcReflectanceMethodEnum, slotMapIfcReflectanceMethodEnum, encodedDataIfcReflectanceMethodEnum);
export { IfcReflectanceMethodEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcReflectanceMethodEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcReflectanceMethodEnumSearch, input, cursor, endCursor);
}
